<div
  *ngIf="drawer.isOpen()"
  class="md-backdrop"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="'mobile.menuDrawer.title' | translate"
  (click)="onBackdropClick($event)"
>
  <aside class="md-panel" (click)="$event.stopPropagation()">
    <!-- User identity block — paridade com o header desktop, que esconde
         o avatar/nome no mobile. (TASK-59145) -->
    <section class="md-user" *ngIf="currentUser$ | async as user">
      <div class="md-user-avatar" [class.has-photo]="(userPhoto$ | async)">
        <img
          *ngIf="(userPhoto$ | async) as photo"
          [src]="photo"
          [alt]="user.name"
          class="md-user-photo"
        >
        <span *ngIf="!(userPhoto$ | async)" class="md-user-initials">
          {{ getInitials(user.name) }}
        </span>
      </div>
      <div class="md-user-meta">
        <p class="md-user-name">{{ truncateName(user.name) }}</p>
        <p class="md-user-lab">
          {{ (laboratoryRazaoSocial$ | async) || ('layout.header.systemName' | translate) }}
        </p>
      </div>
    </section>

    <header class="md-header">
      <button
        type="button"
        class="md-back"
        *ngIf="currentPath.length > 0; else titleSlot"
        [attr.aria-label]="'mobile.menuDrawer.back' | translate"
        (click)="goBack()"
      >
        ‹
      </button>
      <ng-template #titleSlot>
        <span class="md-back md-back-spacer" aria-hidden="true">&nbsp;</span>
      </ng-template>

      <h2 class="md-title">
        {{ currentPath.length > 0 ? headerTitle : ('mobile.menuDrawer.title' | translate) }}
      </h2>

      <button
        type="button"
        class="md-close"
        [attr.aria-label]="'mobile.menuDrawer.close' | translate"
        (click)="closeDrawer()"
      >
        ×
      </button>
    </header>

    <nav class="md-nav" [attr.aria-label]="'mobile.menuDrawer.title' | translate">
      <p class="md-empty" *ngIf="isEmpty">
        {{ 'mobile.menuDrawer.empty' | translate }}
      </p>

      <ul class="md-list" *ngIf="!isEmpty">
        <li class="md-item" *ngFor="let item of visibleItems; trackBy: trackById">
          <!-- Folder: drill in. -->
          <button
            *ngIf="hasChildren(item)"
            type="button"
            class="md-row md-row-folder"
            (click)="goInto(item)"
          >
            <lucide-icon class="md-row-icon" [name]="getIconName(item)" [size]="20"></lucide-icon>
            <span class="md-row-label">{{ item.label }}</span>
            <span class="md-row-chevron" aria-hidden="true">›</span>
          </button>

          <!-- Overlay leaf (TASK-60341, e.g. Estabelecimento de Saúde): opens an
               in-app modal via the service instead of navigating — the
               /health-facilities route was removed. -->
          <button
            *ngIf="!hasChildren(item) && opensAsOverlay(item)"
            type="button"
            class="md-row md-row-leaf"
            (click)="onOverlayLeafClick(item)"
          >
            <lucide-icon class="md-row-icon" [name]="getIconName(item)" [size]="20"></lucide-icon>
            <span class="md-row-label">{{ item.label }}</span>
          </button>

          <!-- Leaf: navigate via routerLink and let NavigationEnd close us. -->
          <a
            *ngIf="!hasChildren(item) && !opensAsOverlay(item) && item.route"
            class="md-row md-row-leaf"
            [routerLink]="item.route"
            [routerLinkActive]="'is-active'"
            [routerLinkActiveOptions]="{ exact: false }"
            (click)="onLeafClick(item)"
          >
            <lucide-icon class="md-row-icon" [name]="getIconName(item)" [size]="20"></lucide-icon>
            <span class="md-row-label">{{ item.label }}</span>
          </a>

          <!-- Leaf without a route (defensive — should not happen in practice). -->
          <button
            *ngIf="!hasChildren(item) && !opensAsOverlay(item) && !item.route"
            type="button"
            class="md-row md-row-leaf md-row-disabled"
            (click)="onLeafClick(item)"
          >
            <lucide-icon class="md-row-icon" [name]="getIconName(item)" [size]="20"></lucide-icon>
            <span class="md-row-label">{{ item.label }}</span>
          </button>
        </li>
      </ul>
    </nav>

    <!-- Footer com logout — paridade com o sidebar desktop. (TASK-59145) -->
    <footer class="md-footer">
      <div class="md-footer-links">
        <a routerLink="/legal/termos" target="_blank" rel="noopener" (click)="closeDrawer()" class="md-footer-link">{{ 'layout.sidebar.footer.terms' | translate }}</a>
        <span class="md-footer-sep" aria-hidden="true">·</span>
        <a routerLink="/legal/privacidade" target="_blank" rel="noopener" (click)="closeDrawer()" class="md-footer-link">{{ 'layout.sidebar.footer.privacy' | translate }}</a>
      </div>
      <button type="button" class="md-footer-logout" (click)="logout()">
        <lucide-icon name="log-out" [size]="18" aria-hidden="true"></lucide-icon>
        <span>{{ 'layout.sidebar.footer.logout' | translate }}</span>
      </button>
    </footer>
  </aside>
</div>
